// extracted by mini-css-extract-plugin
module.exports = {"category":"_1xjc8aTIoKLyPRnukOtpMW","name":"_2WCjeuJvxsn_32SKsT2mXV loadingGlow","product":"ctUFjgEM2QfJ5t0kCcFjq loadingGlow"};